


























































































































































































































import Vue from 'vue';

export default Vue.extend({
  name: 'Home',

  components: {

  },

  data() {
    return {
      dialog: false,
      showAnswer: false,
      currQuestionIdx: 0,
      playersCorrect: [],
    };
  },

  computed: {
    questionsCount(): number {
      return this.$store.getters.selectedQuestions.length;
    },
    gameFinished(): boolean {
      return this.currQuestionIdx >= this.$store.getters.selectedQuestions.length;
    },
    questions() {
      return this.$store.getters.selectedQuestions;
    },
    players() {
      return this.$store.getters.players;
    },
  },

  methods: {
    toggleShowAnswer(): void {
      this.showAnswer = !this.showAnswer;
    },
    exit(): void {
      this.$router.push('/');
    },
    reset(): void {
      this.dialog = false;
      this.showAnswer = false;
      this.currQuestionIdx = 0;
      this.$store.dispatch('resetScore');
    },
    nextQuestion(): void {
      this.$store.dispatch('updateScore', this.playersCorrect);

      this.dialog = false;
      this.playersCorrect = [];
      this.showAnswer = false;
      this.currQuestionIdx += 1;
    },

  },

});
